import {Currency} from './currency';

export enum PaymentStatus {
  PAID = 'paid',
  UNPAID = 'unpaid'
}

export class Invoice {
  invoiceNumber: string;
  documentId: number;
  doccumentType: string;
  invoicePdfUrl: string;
  invoiceDate: string;
  dueDate: string;
  amount: number;
  currency: Currency;
  status: PaymentStatus;

  constructor(invoiceNumber: string, invoicePdfUrl: string, documentId: number, doccumentType: string, invoiceDate: string, dueDate: string,
              invoiceAmount: number, invoiceCurrency: Currency, status: boolean) {
    this.invoiceNumber = invoiceNumber;
    this.invoicePdfUrl = invoicePdfUrl;
    this.invoiceDate = invoiceDate;
    this.dueDate = dueDate;
    this.amount = invoiceAmount;
    this.currency = invoiceCurrency;
    if (status) {
      this.status = PaymentStatus.PAID;
    } else {
      this.status = PaymentStatus.UNPAID;
    }
    this.documentId = documentId;
    this.doccumentType = doccumentType;
  }
}



// WEBPACK FOOTER //
// ./src/models/Billing/invoice.ts